
interface ScienceCard {
  title: string;
  explanation: string;
  experiment?: string;
}

export const generateScienceCards = (
  ingredients: string[],
  steps: Array<{ instruction: string }>,
): ScienceCard[] => {
  const cards: ScienceCard[] = [];
  
  // Convert ingredients and steps to lowercase for easier matching
  const ingredientsLower = ingredients.map(i => i.toLowerCase());
  const stepsLower = steps.map(s => s.instruction.toLowerCase());
  
  // Check for baking soda or powder
  if (ingredientsLower.some(i => i.includes('baking soda') || i.includes('baking powder'))) {
    cards.push({
      title: "The Rise and Shine of Baking",
      explanation: "Baking soda and powder are like tiny bubblemakers! When they meet liquid and heat, they create carbon dioxide bubbles that make your food fluffy and light.",
      experiment: "Compare two small dough balls - one with baking soda and one without. Watch how they rise differently in the oven!"
    });
  }

  // Check for egg usage
  if (ingredientsLower.some(i => i.includes('egg'))) {
    cards.push({
      title: "Egg-cellent Science",
      explanation: "Eggs are like the glue in your recipe! The proteins in eggs help bind ingredients together and create structure.",
      experiment: "Try making two small batches - one with a whole egg and one with just egg white. Notice the difference in texture!"
    });
  }

  // Check for cold ingredients or chilling steps
  if (ingredientsLower.some(i => i.includes('cold') || i.includes('chilled')) ||
      stepsLower.some(s => s.includes('chill') || s.includes('refrigerate'))) {
    cards.push({
      title: "The Cold Factor",
      explanation: "Cold ingredients help control how your food turns out. For example, cold butter creates flaky layers in pastries!",
      experiment: "Make two portions of dough - chill one for an hour and use the other right away. See how they bake differently!"
    });
  }

  // Check for mixing or beating steps
  if (stepsLower.some(s => s.includes('mix') || s.includes('beat') || s.includes('whisk'))) {
    cards.push({
      title: "Mix Master Science",
      explanation: "Mixing helps combine ingredients and can also add air into your recipe. Different mixing speeds can create different textures!",
      experiment: "Try mixing the same ingredients at different speeds - one gently and one vigorously. Notice how the texture changes!"
    });
  }

  return cards;
};
